
import Upload from '@/components/Upload/Upload'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import base64 from 'vux/src/tools/base64/index.js'

import Previewer from '@/components/Previewer/Previewer'
export default {
name: 'face_page',
directives: {
TransferDom
},
data() {
return {
options: {
bgOpacity: 0.9,
loop: false,
clickToCloseNonZoomable: false,
tapToClose: false,
errorMsg:
'<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>',
isClickableElement: function(el) {
if (
navigator.userAgent.indexOf('Android') > -1 ||
navigator.userAgent.indexOf('Adr') > -1
) {
return true
} else {
return false
}
}
}
}
},
computed: {
faceList() {
if (this.$store.state.live.faceList) {
this.initFaceList(this.$store.state.live.faceList)
}
return this.$store.state.live.faceList
},
previewerList() {
if (this.$store.state.live.faceList) {
return this.initPreviewPhotoList(this.$store.state.live.faceList)
}
return this.$store.state.live.faceList
}
},
mounted() {
setTimeout(() => {
this.$refs.upload.init()
}, 500)
},
methods: {
// 初始化加水印
initFaceList(list) {
let watermark = base64.encode(this.$store.state.live.detail.Watermark)
// 返回添加水印并裁剪尺寸为1000*1000的图
let encodeUrl
encodeUrl = encodeURIComponent(
`imageslim|watermark/1/image/${watermark}/dissolve/90/gravity/SouthEast`
)
let arr = []
list.map(item => {
item.Url = `${item.Url}`
arr.push(item)
})
return arr
},
initPreviewQiniu(live) {
// 获取base64转码后的水印图
let watermark = base64.encode(this.$store.state.live.detail.Watermark)
// 返回添加水印并裁剪尺寸为1000*1000的图
let encodeUrl
encodeUrl = encodeURIComponent(
`imageslim|watermark/1/image/${watermark}/dissolve/90/gravity/SouthEast`
)
// console.log('=====///', encodeUrl)
let url = `${live.Url}?${encodeUrl}`
return url
},
initPreviewPhotoList(list) {
// 构建一个新previewer数组
let preview_arr = []
if (list) {
list.map((item, index) => {
// console.log(item)
let url = ''
let originUrl = this.initOriginPic(item)
url = this.initPreviewQiniu(item)
preview_arr.push({
info: item,
src: url,
isOrigin: false,
w: item.Width,
h: item.Height,
origin_url: originUrl
})
})
}
return preview_arr
},
initOriginPic(live) {
let new_url = ''
if (live) {
let img_watermark = base64.encode(
this.$store.state.live.detail.Watermark || ''
)
let encodeUrl
encodeUrl = encodeURIComponent(
`watermark/1/image/${img_watermark}/dissolve/90/gravity/SouthEast`
)
new_url = `${live.Url}?${encodeUrl}`
}
return new_url
},
show(index) {
this.$refs.previewer.show(index)
},
uploaded(url) {
let _this = this
let liveId = this.$route.params.liveId
_this.$vux.loading.show({
text: '面孔智能识别中...'
})
// 调用人脸识别接口
this.$store
.dispatch({
type: 'getFaceList',
liveId: liveId,
url: url
})
.then(() => {
_this.$vux.loading.hide()
// 跳转到人脸识别结果页面
this.$router.push({
name: 'FaceRecogPage',
params: { liveId: liveId }
})
})
.catch(err => {
_this.$vux.toast.show({
type: 'warn',
text: err.data.Message
})
setTimeout(() => {
_this.$vux.toast.hide()
}, 3000)
})
}
},
components: {
Upload,
Previewer
}
}



// WEBPACK FOOTER //
// ./src/pages/live/FaceRecogPage.vue